import { DRAFT_PREFIX } from "../components/modal_windows/note_modal_window/note_draft_storage";
import { VOICE_KEY_STORAGE_KEY } from "../components/tiptap_editor/voice/voice_key_storage";
import { DRAFT_ANSWERS_KEY } from "../../pages/admin/admin_page_questions/admin_questions_functions";
import {
	COMPARISON_TARGET_KEY,
	LAST_PARAMS_KEY,
	NOTE_SLOTS_KEY,
} from "../../pages/bible_next/lib/storage_keys";

// What one account leaves in this browser that the next person to sign in on the same device
// must not see (BTS-437): unsent text, a secret, and where the reader was. Device preferences —
// font, theme, column widths, language — stay: they belong to the device, not the account.
export const PRIVATE_KEYS = [
	DRAFT_ANSWERS_KEY, // answers to questions an admin had started
	VOICE_KEY_STORAGE_KEY, // someone's own OpenAI key for dictation
	LAST_PARAMS_KEY, // last place read in the Bible
	COMPARISON_TARGET_KEY, // the passage being compared
	NOTE_SLOTS_KEY, // which notes the note columns had open
];
export const PRIVATE_PREFIXES = [DRAFT_PREFIX]; // unsaved note drafts

export const clearPrivateStorage = (storage: Storage = localStorage): void => {
	try {
		const keys = Array.from({ length: storage.length }, (_, i) => storage.key(i)).filter(
			(key): key is string =>
				key !== null &&
				(PRIVATE_KEYS.includes(key) || PRIVATE_PREFIXES.some(prefix => key.startsWith(prefix))),
		);
		keys.forEach(key => storage.removeItem(key));
	} catch {
		// Blocked site data throws; there is nothing stored to leak then.
	}
};
